import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  convertUTCStringToOffset,
  getFormattedDate,
  getFormattedDateTime,
  isLargeScreen,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { UserProfileService } from '../../../../profile/user-profile/user-profile.service';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { FileUploadComponent } from '../../../../shared/components/file-upload/file-upload.component';
import { MediaPreviewComponent } from '../../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { ModifyLetterheadLogoComponent } from '../../../../shared/components/modify-letterhead-logo/modify-letterhead-logo.component';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { DeviceInfoService } from '../../../../shared/services/device-info.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { WebSocketService } from '../../../../shared/services/web-socket.service';
import { IncidentsService } from '../incidents.service';

@Component({
  selector: 'gtapp-review-incident',
  templateUrl: './review-incident.component.html',
  styleUrl: './review-incident.component.scss',
  standalone: false,
})
export class ReviewIncidentComponent implements OnInit, OnDestroy {
  largeView: Boolean = isLargeScreen;

  webSocketSubscription: any;
  subscriberUserId: any;
  loggedInDeviceID: string = this.deviceInfoService.getUniqueDeviceID();
  isAdmin: boolean = false;
  isDispatchUser: boolean = false;
  routeSubscription: any;
  dialogRef: any;
  detailData: any;
  incidentId: any;
  incidentCommentFiles: any = [];
  sumamaryTableData: any = [];

  reportContactsData: any = { site_contacts: [], client_contacts: [] };

  selectedReportRecipientSet = new Set();

  newValue: any;

  selectedIncidentTypeList: any = [];
  selectedIncidentTypeIdList: any = [];
  initalIncidentTypeList: any = [];
  previousincidentTypeValue: any;
  incidentTypeList: any = [];
  previousTextValue: any;

  subscriberInfo: any;
  today = new Date();

  incidentTime: any = new Date();
  resolutionTime: any = new Date();

  incidentComplete: boolean = false;

  timeZoneData: any;
  timeZoneOffset: any;
  constructor(
    private viewContainerRef: ViewContainerRef,
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private deviceInfoService: DeviceInfoService,
    private dialogService: ModalDialogueService,
    private router: Router,
    private dataCheckService: DataCheckService,
    private toasterService: ToasterService,
    private route: ActivatedRoute,
    private webSocketService: WebSocketService,
    private incidentService: IncidentsService,
    private profileService: UserProfileService,
  ) {
    const userData = this.appService.getUserData();

    this.isAdmin = this.dataCheckService.isUserAdmin();
    this.isDispatchUser = this.dataCheckService.isDispatchUser();

    this.subscriberUserId = userData?.subscriber?.subscriber_user_id;

    this.routeSubscription = this.route.params.subscribe({
      next: (params) => {
        if (params?.['inKey']) {
          this.incidentId = params?.['inKey'];

          this.getIncidentDetail();
        }
      },
    });

    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        const isSameUserOnAnotherDevice =
          this.subscriberUserId === event?.request_user?.subs_id &&
          this.loggedInDeviceID &&
          this.loggedInDeviceID !== event?.request_user?.logged_in_device_id;
        const isAnotherUser =
          this.subscriberUserId !== event?.request_user?.subs_id;

        const allowUser = isSameUserOnAnotherDevice || isAnotherUser;

        if (
          event?.event === 'individual_incident_update' &&
          event?.data?.data?.id === this.detailData?.id &&
          allowUser
        ) {
          // update the changes made by someone else in realtime

          setTimeout(() => {
            this.detailData = event?.data?.data;
            this.formatData(event?.data);
          }, 100);
        }
        if (
          ['user_incident_update'].includes(event?.event) &&
          event?.data?.delete &&
          event?.data?.id === this.detailData?.id &&
          allowUser
        ) {
          // one of the user has deleted the job
          // route to home page.
          this.toasterService.setMessage({
            successMessage: `This incident was just deleted by ${event?.request_user?.user_name}`,
            errorMessage: '',
          });
          this.router.navigate(['/']);
        }
      });
  }
  ngOnDestroy() {
    if (this.webSocketSubscription) this.webSocketSubscription?.unsubscribe();
    if (this.routeSubscription) this.routeSubscription?.unsubscribe();
  }
  ngOnInit(): void {
    this.getDeviceID();
  }
  getDeviceID() {
    if (!this.loggedInDeviceID) {
      this.loggedInDeviceID = this.deviceInfoService.getUniqueDeviceID();
    }
  }
  getSubscriberInfo() {
    this.profileService
      .fetchCompanyDetails({
        preview_report: 1,
        site_id: this.detailData?.site?.id,
      })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.subscriberInfo = response?.data;
        }
      });
  }
  getIncidentDetail() {
    this.spinnerService.show();
    this.incidentService
      .retrieveIncident(this.incidentId)
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.formatData(response);
          this.getAllReportContacts();
          this.getSubscriberInfo();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }

        this.spinnerService.hide();
      });
  }
  getAllReportContacts() {
    this.reportContactsData = { site_contacts: [], client_contacts: [] };
    this.incidentService
      .retrieveIncident(this.incidentId, { get_contacts: 1 })
      .subscribe((response: any) => {
        if (response.status === 'success') {
          this.reportContactsData = {
            site_contacts: response?.data?.site_contacts || [],
            client_contacts: response?.data?.client_contacts || [],
          };
          const defaultSelectedIds = (response?.data?.site_contacts || [])?.map(
            (contact: any) => contact?.id,
          );

          this.selectedReportRecipientSet = new Set(defaultSelectedIds);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response.message,
          });
        }
      });
  }
  openupdateIncidentTypeTemplate(template: TemplateRef<any>) {
    this.selectedIncidentTypeList = this.detailData?.incident_types;
    if (!this.selectedIncidentTypeList?.length) {
      this.selectedIncidentTypeList.push({ isFocused: true });
    }
    this.getIncidentTypes();

    this.previousincidentTypeValue = this.detailData?.incident_type;
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  getIncidentTypes(params?: any) {
    this.incidentService.fetchIncidentTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.incidentTypeList = res['data'];
        this.initalIncidentTypeList = JSON.parse(JSON.stringify(res?.data));
      }
    });
  }
  onSearchIncidentType(event: any) {
    this.previousincidentTypeValue = event.target.value;
    if (event.target.value.length) {
      this.incidentTypeList = this.initalIncidentTypeList?.filter((type: any) =>
        type?.name?.toLowerCase()?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.incidentTypeList = this.initalIncidentTypeList;
    }
  }
  onSelectIncidentType(event: any, index: number) {
    if (event?.key === 0) {
      this.openAddIncidentTypeForm(index);
    }
    if (event?.id) {
      this.selectedIncidentTypeList[index] = {
        ...event,
        isFocused: false,
      };
      this.getIncidentTypeIdList();
    }
  }
  openAddIncidentTypeForm(index: number) {
    if (this.previousincidentTypeValue.length > 0) {
      var requestData = { name: this.previousincidentTypeValue };
      this.incidentService
        .createIncidentType(requestData)
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: '',
              successMessage: response['message'],
            });
            this.previousincidentTypeValue = '';
            this.onSelectIncidentType(response?.data, index);
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Incident Name can't be empty",
        successMessage: '',
      });
    }
  }
  editEventTimeStamp(rowData: any, template: any) {
    const currentValue = getFormattedDateTime(
      rowData?.user_provided_timestamp
        ? rowData?.user_provided_timestamp
        : rowData?.updated_at,
    );
    let maxDateTime = new Date();
    let minDateTime: any;
    const dialogRef = this.dialogService.open(
      template,
      {
        data: {
          name:
            rowData?.event_action === 11
              ? 'Photo (Source: Device Library)'
              : 'Photo (Source: Camera)',
          currentValue: currentValue,
          newValue: currentValue,
          minDateTime: minDateTime ? getFormattedDateTime(minDateTime) : null,
          maxDateTime: maxDateTime ? getFormattedDateTime(maxDateTime) : null,
        },
      },
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        let body: any = {
          incident_id: this.detailData?.id,
          event_id: rowData?.id,
          user_provided_timestamp: new Date(
            value?.newValue || value?.currentValue,
          ),
          change_event_timestamp: 1,
        };
        this.updateIncident(body);
      }
    });
  }
  editTimeStamp(_type: string, timeStampTempRef: any) {
    let updatedAtMax: any;
    let updatedAtMin: any;
    let maxDateTime = new Date();
    let minDateTime: any;
    let currentValue: any;
    let _typeString: string = '';

    switch (_type) {
      case 'iTime':
        currentValue = getFormattedDateTime(this.detailData?.incident_time);
        _typeString = 'Incident';

        // max can be the timestamp of resolution time

        updatedAtMax = this.detailData?.resolution_time;

        maxDateTime = updatedAtMax ? new Date(updatedAtMax) : new Date();
        minDateTime = minDateTime;
        break;
      case 'rTime':
        currentValue = getFormattedDateTime(this.detailData?.resolution_time);
        _typeString = 'Resolution';
        // min can be the timestamp of incident time
        updatedAtMin = this.detailData?.incident_time;

        minDateTime = updatedAtMin ? new Date(updatedAtMin) : new Date();

        maxDateTime = new Date(); // max can be now()
        break;
    }

    const dialogRef = this.dialogService.open(
      timeStampTempRef,
      {
        data: {
          name: _typeString,
          currentValue: currentValue,
          newValue: currentValue,
          minDateTime: minDateTime
            ? getFormattedDateTime(minDateTime)
            : minDateTime,
          maxDateTime: maxDateTime
            ? getFormattedDateTime(maxDateTime)
            : maxDateTime,
        },
      },
      this.viewContainerRef,
    );

    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        let body: any = { incident_id: this.detailData?.id };
        if (_type == 'iTime') {
          let dateTimeString = new Date(value?.newValue);
          body['incident_time'] = dateTimeString;
        } else {
          let dateTimeString = new Date(value?.newValue);
          body['resolution_time'] = dateTimeString;
        }

        if (body) {
          this.updateIncidentDetails(body);
        }
      }
    });
  }
  changeStatusTimeStamp(event: any, eventData: any) {
    const selectedTime = event?.target.value
      ? new Date(event?.target.value).getTime()
      : new Date(eventData?.currentValue).getTime();

    let valid = true;

    if (eventData?.minDateTime)
      valid = selectedTime >= new Date(eventData?.minDateTime)?.getTime();

    if (eventData?.maxDateTime)
      valid =
        valid && selectedTime <= new Date(eventData?.maxDateTime)?.getTime();

    eventData.valid = valid;
  }

  editComment(data?: any) {
    if (!data?.id && !this.newValue?.trim()) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Comment cannot be empty',
      });
      return;
    }
    this.spinnerService.show();
    let body: any = {
      incident_id: this.detailData?.id,
      comment: this.newValue,
    };
    if (Object.keys(data).length) {
      body.id = data?.id;
      body.edit_comment = 1;
    }
    if (body) {
      this.updateIncident(body);
    }
  }
  deleteComment(data: any) {
    this.spinnerService.show();
    let body: any = {
      incident_id: this.detailData?.id,
      comment: '',
    };
    if (Object.keys(data).length) {
      body.id = data?.id;
      body.edit_comment = 1;
    }
    if (body) {
      this.updateIncident(body);
    }
  }

  redirectToSite(route = 'site') {
    if (route === 'site') {
      this.router.navigate(
        ['/view-site', { sKey: String(this.detailData?.site?.id) }],
        { fragment: 'jc' },
      );
    } else {
      this.router.navigate(
        ['/view-client', { cKey: String(this.detailData?.company?.id) }],
        { fragment: 'jc' },
      );
    }
  }
  scrollToSection(event: Event, sectionId: string) {
    event.preventDefault();
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  }
  formatData(response: any) {
    this.detailData = response?.data;
    this.selectedReportRecipientSet = new Set();

    const hideGuardColumn = this.detailData?.additional_info?.hide_guard_column;

    if (typeof hideGuardColumn !== 'boolean') {
      this.detailData.additional_info.hide_guard_column = true;
    }

    this.timeZoneData = response?.time_zone_data;
    this.timeZoneOffset = convertUTCStringToOffset(
      this.timeZoneData?.time_zone_diff,
    );

    this.incidentComplete =
      this.detailData?.status == 1 ||
      response?.history?.some((item: any) => [8].includes(item?.event_action));

    this.incidentCommentFiles = [
      ...response?.history?.filter((item: any) =>
        //1 = added comment
        //2 = take photo from camera
        //3 = comment changed
        //5 = corrective actions changed
        //7 = incident time changed
        //8 = incident report sent
        //9 = report re-sent
        //10 = incident type changed
        //11 = uploaded photo from device
        [2, 11].includes(item?.event_action),
      ),
    ];
    this.sumamaryTableData = [
      ...response?.history?.filter(
        (item: any) =>
          //1 = added comment
          //2 = take photo from camera
          //3 = comment changed
          //5 = corrective actions changed
          //7 = incident time changed
          //8 = incident report sent
          //9 = report re-sent
          //10 = incident type changed
          //11 = uploaded photo from device
          [2, 11].includes(item?.event_action) &&
          !this.detailData?.additional_info?.hide_uploads,
      ),
    ];

    this.appService.initializeBootstrapTooltips();
  }
  deleteRestoreUserUpdate(event: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title:
          event?.type === 'delete' ? 'Remove From Report?' : 'Show in Report?',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        let body: any = {
          id: event?.event?.id,
          incident_id: this.detailData?.id,
        };
        body[event?.type === 'delete' ? 'delete_update' : 'restore_update'] = 1;

        this.updateIncident(body);
      }
    });
  }
  openCommentTemplate(template: TemplateRef<any>, commentData?: any) {
    let dialogContext: any = {};
    if (commentData) {
      this.newValue = commentData?.detail;
      this.previousTextValue = this.newValue;
      dialogContext = commentData;
    }
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: dialogContext,
      },
      this.viewContainerRef,
    );
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value) {
        this.formatData(value);
        this.dialogRef.close();
      }
    });
  }
  updateIncident(body: any, params?: any) {
    let requestParams: any = { preview_report: 1, ...params };
    this.spinnerService.show();
    this.incidentService
      .updateIncident(body, requestParams)
      .then((response: any) => {
        if (response?.status == 'success') {
          if (response?.data) {
            this.detailData = response['data'];

            this.formatData(response);

            this.toasterService.setMessage({
              successMessage: response['message'],
              errorMessage: '',
            });
          }
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }

        this.spinnerService.hide();
      });
  }
  openExtraInfoTemplate(template: TemplateRef<any>, extrainfoType?: string) {
    this.newValue =
      extrainfoType == 'ca'
        ? this.detailData?.corrective_actions
        : this.detailData?.information;
    this.previousTextValue = this.newValue;

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: { extrainfoType: extrainfoType },
      },
      this.viewContainerRef,
    );
  }
  updateExtraInfo(infoData: any) {
    let body: any = { incident_id: this.detailData?.id };
    body[
      infoData?.extrainfoType == 'ca' ? 'corrective_actions' : 'information'
    ] = this.newValue;
    if (body) {
      this.updateIncidentDetails(body);
    }
  }
  clearAndFocusTextBox(elementId: string) {
    this.newValue = '';
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  addNewSiteKeyField() {
    this.selectedIncidentTypeList = this.selectedIncidentTypeList?.filter(
      (element: any) => element?.id,
    );
    this.selectedIncidentTypeList.forEach(
      (element: any) => (element.isFocused = false),
    );
    this.selectedIncidentTypeList.push({ isFocused: true });
    this.incidentTypeList = JSON.parse(
      JSON.stringify(this.initalIncidentTypeList || []),
    );
    this.incidentTypeList = this.incidentTypeList?.filter(
      (iType: any) =>
        !this.selectedIncidentTypeList?.some(
          (selectedIType: any) => selectedIType?.id == iType?.id,
        ),
    );
    this.shiftFocus('iTypeLookupField');
    this.getIncidentTypeIdList();
  }
  deleteSiteKeyField(index: number) {
    this.selectedIncidentTypeList.splice(index, 1);
    if (!this.selectedIncidentTypeList?.length) {
      this.selectedIncidentTypeList.push({ isFocused: true });
      this.shiftFocus('iTypeLookupField');
    }
    this.getIncidentTypeIdList();
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      element?.click();

      element?.focus();
    });
  }
  openIncidentTypeLookup(index: number) {
    this.selectedIncidentTypeList[index] = {
      isFocused: true,
    };
    this.shiftFocus('iTypeLookupField');
    this.incidentTypeList = JSON.parse(
      JSON.stringify(this.initalIncidentTypeList || []),
    );
    this.incidentTypeList = this.incidentTypeList?.filter(
      (iType: any) =>
        !this.selectedIncidentTypeList?.some(
          (selectedIType: any) => selectedIType?.id == iType?.id,
        ),
    );
    this.getIncidentTypeIdList();
  }
  getIncidentTypeIdList() {
    const listWithIds = this.selectedIncidentTypeList?.filter(
      (iType: any) => iType?.id,
    );
    this.selectedIncidentTypeIdList = [
      ...new Set(listWithIds?.map((iType: any) => iType?.id)),
    ];
  }
  updateIncidentTypeList() {
    const listWithIds = this.selectedIncidentTypeList?.filter(
      (iType: any) => iType?.id,
    );
    this.selectedIncidentTypeIdList = [
      ...new Set(listWithIds?.map((iType: any) => iType?.id)),
    ];
    this.updateIncidentDetails({
      incident_types: this.selectedIncidentTypeIdList,
      incident_id: this.detailData?.id,
    });
  }
  updateIncidentDetails(body: any, params?: any, showToaster = true) {
    this.spinnerService.show();
    this.incidentService
      .updateIncidentDetails(body, params)
      .then((response: any) => {
        if (response?.status == 'success') {
          if (response?.data) {
            this.detailData = response['data'];

            this.formatData(response);
            if (showToaster)
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
          }
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }

        this.spinnerService.hide();
      });
  }
  sendReport(template: any) {
    const dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        if (!this.selectedReportRecipientSet.size) {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: 'No recipients selected',
          });
          return;
        }
        let body: any = {
          incident_id: this.detailData?.id,
          user_ids: [...this.selectedReportRecipientSet],
          send_report: 1,
        };
        this.updateIncidentDetails(body);
      }
    });
  }
  selectAllContactReportRecipients(event: any, contactList: any) {
    const checked = event.target.checked;
    const contactIds = contactList?.map((item: any) => item?.id) || [];
    if (checked) {
      contactIds?.forEach((contactId: any) => {
        this.selectedReportRecipientSet.add(contactId);
      });
    } else {
      contactIds?.forEach((contactId: any) => {
        if (this.selectedReportRecipientSet.has(contactId)) {
          this.selectedReportRecipientSet.delete(contactId);
        }
      });
    }
  }
  selectUnselectRecipients(contact: any) {
    if (this.selectedReportRecipientSet.has(contact?.id)) {
      this.selectedReportRecipientSet.delete(contact?.id);
    } else {
      this.selectedReportRecipientSet.add(contact?.id);
    }
  }
  onOpenImage(event: any, data: any) {
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;

    this.dialogRef = this.dialogService.open(MediaPreviewComponent, {
      data: { mediaSrc: srcAttr.nodeValue, timeStamp: data.updated_at },
    });
  }
  openReportDateTemplate(template: any) {
    const currentValue = getFormattedDate(
      this.detailData?.additional_info?.report_date
        ? new Date(this.detailData?.additional_info?.report_date)
        : new Date(),
    );

    const dialogRef = this.dialogService.open(
      template,
      {
        data: {
          currentValue: currentValue,
          newValue: currentValue,
          minDateTime: null,
          maxDateTime: getFormattedDate(new Date()),
        },
      },
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value) {
        let body: any = {
          incident_id: this.detailData?.id,
          report_date: new Date(value?.newValue).getTime(),
        };
        this.updateIncidentDetails(body);
      }
    });
  }
  openCamPopup() {
    this.dialogRef = this.dialogService.open(FileUploadComponent, {
      data: { showFrom: 'updateIncident' },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value && value !== 'error') {
        this.onFileSubmit(value);
      } else if (value == 'error') {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'ERROR: Unable to access your camera',
        });
      }
    });
  }
  onFileSubmit(imageData: any) {
    if (!imageData?.actualFileUpload) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'ERROR: Please add a photo',
      });
    } else {
      this.spinnerService.show('Uploading - Please Wait');
      let fileData: FormData = new FormData();

      fileData.append('file', imageData?.actualFileUpload);
      if (imageData?.newComment) {
        fileData.append('comment', imageData?.newComment);
      }
      let url = `incident/update_incident`;
      fileData.append('incident_id', this.detailData?.id);
      fileData.append('image_source', imageData?.uploadType);
      if (imageData?.exifData && Object.values(imageData?.exifData)?.length) {
        fileData.append('exif_data', JSON.stringify(imageData?.exifData));
      }

      this.appService.formDataApi(url, fileData).then((response: any) => {
        if (response?.data) {
          this.formatData(response);
        }

        this.spinnerService.hide();
      });
    }
  }
  checkAndAddIncidentType(index: number) {
    if (
      this.previousincidentTypeValue?.length > 0 &&
      !this.incidentTypeList?.length
    ) {
      this.openAddIncidentTypeForm(index);
    }
  }
  modifyLetterHeadLogo() {
    const dialogRef = this.dialogService.open(ModifyLetterheadLogoComponent, {
      data: {
        logoUsed: this.subscriberInfo?.logo_used,
        siteData: {
          id: this.detailData?.site?.id,
          company_name: this.detailData?.site?.company_name,
        },
        clientData: {
          id: this.detailData?.company?.id,
          company_name: this.detailData?.company?.company_name,
          is_subcontracting: this.detailData?.company?.is_subcontracting,
        },
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getSubscriberInfo();
      }
    });
  }
  markIncidentComplete() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Mark Complete',
        message: 'This will not send report',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        this.updateIncidentDetails({
          mark_complete: 1,
          incident_id: this.detailData?.id,
        });
      }
    });
  }
}
